import React, { useState } from "react";

import { Pagination, Table } from "clearsense-ui/components";

const ConversionTable = ({
  conversions,
  selectedColumns,
  setShowModal,
  setSelectedRow,
}) => {
  const [checkedRows, setCheckedRows] = useState([]);
  const currentPage = 1;

  return (
    <div className="flex flex-col justify-between flex-grow mt-8 cs-ui-table-background">
      <Table
        fixedHeight
        columnData={selectedColumns}
        rowData={conversions.length !== 0 ? conversions : []}
        rowKey={record => record.id}
        onRowSelect={(_, selectedRows) => setCheckedRows(selectedRows)}
        onRowClick={(r_, _, rowIndex) => {
          setSelectedRow(conversions[rowIndex]);
          setShowModal(true);
        }}
        rowSelection={{
          onSelect: (_, __, selectedRows) => setCheckedRows(selectedRows),
          selectedRowKeys: checkedRows.map(row => row.id),
          onSelectAll: () =>
            checkedRows.length === conversions.length
              ? setCheckedRows([])
              : setCheckedRows(conversions),
        }}
      />
      {conversions.length !== 0 && (
        <Pagination
          currentPage={currentPage}
          showResultsPerPage
          totalRecordsCount={conversions.length}
          className="px-8 py-2"
        />
      )}
    </div>
  );
};

export default ConversionTable;
